import $i18n from 'panda-i18n';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { CnCascaderSelect, } from '@/components/cn-cascader-select';
import { getChildren, search } from './service';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import flattenDeep from 'lodash/flattenDeep';
import DepartmentValueItem from './department-value-item';
/** 一级部门code */
const TOP_DEPARTMENT_CODE = '22187';
const CnDepartmentSelect = (props) => {
    const { 
    // 不支持外部传入的dataSource，排除掉
    dataSource: propDataSource, mokelay = true, host, path, ...others } = props;
    const [dataSource, setDataSource] = useState([]);
    const [searchResult, setSearchResult] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const timer = React.useRef();
    // 首次加载，查询一级部门
    useEffect(() => {
        const fetchInitData = async () => {
            const result = await getChildren({
                value: TOP_DEPARTMENT_CODE,
                mokelay,
                host,
                path,
            });
            setDataSource(result);
        };
        fetchInitData();
    }, [host, mokelay, path]);
    // 数据加载，根据父节点查询子部门
    const handleLoadData = useCallback(async (item) => {
        const result = await getChildren({
            value: item.value,
            mokelay,
            host,
            path,
        });
        setDataSource((cur) => {
            const clonedCur = cloneDeep(cur);
            const getTail = (i) => {
                if (i?.children && i?.children.length > 0) {
                    return i?.children.map((m) => getTail(m));
                }
                else {
                    return [i];
                }
            };
            const childrenDepartment = find(flattenDeep(clonedCur.map((m) => getTail(m))), { code: item.value });
            if (childrenDepartment) {
                childrenDepartment.children = result;
            }
            return clonedCur;
        });
    }, [host, mokelay, path]);
    const handleSearch = useCallback((v) => {
        clearTimeout(timer.current);
        timer.current = setTimeout(async () => {
            setSearchValue(v);
            const res = await search({
                value: v,
                mokelay,
                host,
                path,
            });
            setSearchResult(res);
        }, 300);
    }, [host, mokelay, path]);
    const handleVisibleChange = useCallback((visible) => {
        if (visible) {
            setSearchResult([]);
            setSearchValue('');
        }
    }, []);
    return (React.createElement(CnCascaderSelect, { dataSource: searchValue ? searchResult : dataSource, loadData: handleLoadData, placeholder: $i18n.get({
            id: 'PleaseSelectADepartment',
            dm: '请选择部门',
            ns: 'CnDepartmentSelect',
        }), onSearch: handleSearch, onVisibleChange: handleVisibleChange, filterLocal: false, renderContent: (values, separator) => {
            return Array.isArray(values) && values.length > 0 ? (React.createElement(DepartmentValueItem, { items: values, separator: separator, mokelay: mokelay, host: host })) : ('');
        }, useSimpleValue: true, ...others }));
};
CnDepartmentSelect.displayName = 'CnDepartmentSelect';
CnDepartmentSelect.defaultProps = {
    mokelay: true,
    showSearch: true,
};
export { CnDepartmentSelect };
